/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для блока физических/юридических лиц в личном кабинете.
   */
  app.LegalEntityView = app.View.extend({
    
    // Обработчики пользовательских событий
    events: {
      'click [data-legal-entity-id] .remove-legal-entity': 'confirmRemoveLegalEntity',
      'click [data-legal-entity-id] .edit-legal-entity': 'edit',
    },
    additionalOptions: ['owner'],
    run: function () {
      this.legalEntities = this.owner.legalEntities;
    },
    
    edit: function (e) {
      var legalEntityId = $(e.target).parent().data('legal-entity-id');
      
      this.owner.toggle();
      this.owner.legalEntityFormView.render(legalEntityId);
    },
    
    /**
     * Запрос подтверждения удаления физического/юридического лица в личном кабинете.
     * @param {object} e Events.
     */
    confirmRemoveLegalEntity: function (e) {
      this.legalEntityId = $(e.target).parent().data('legal-entity-id');

      this.legalEntity = this.legalEntities.get(this.legalEntityId);
      this.legalEntity.set('is_delete', true);
    }
  });
})(jQuery);

}.call(window));